import { createContext } from "react";

export const ApplicationContext = createContext({
  loggedInUser: null,
  setLoggedInUser: () => {},
  isAdminHrRole: false,
  isManagerRole: false,
  isEmployeeRole: false,
});
